// extracted by mini-css-extract-plugin
export default {"link":"ResetPassword_link__2wV+H"};